import routerOptions0 from "/data/runners/five/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@9.29.0_jiti@2.4._c9759777483e3a774741b740772913ca/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}